import type { CSSProperties } from "react";
import { cn } from "../lib/cn";

export type AmbientOrbProps = {
 className?: string;
 /** Tailwind-compatible color utility class, e.g. bg-primary */
 colorClassName?: string;
 style?: CSSProperties;
};

/**
 * Soft organic background light. Decorative only - never blocks interaction.
 */
export function AmbientOrb({
 className,
 colorClassName = "bg-primary",
 style,
}: AmbientOrbProps) {
 return (
 <div
 aria-hidden
 className={cn("ambient-orb", colorClassName, className)}
 style={style}
 />
 );
}
